module.exports = __webpack_public_path__ + "static/media/overwatch.346d43fe.jpg";